import React from 'react';

export default function Item(props) {
    return (
        <div className="min-h-full h-fit overflow-y-auto flex flex-col">
            <div className="xs_settingsMenu__section grid auto-rows-[50px]">
                <span className="pl-2 flex items-center font-medium text-lg text-cs-10">{props.desc}</span>
                {props.children}
            </div>
        </div>
    );
}
